// extracted by mini-css-extract-plugin
export default {"buttons":"JoinConference_modal_buttons__vP6wa"};